import { sendPasswordResetEmail } from 'firebase/auth';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from '../../../common/constants/ViewEnum';
import { auth } from '../../../config/firebaseConfig';
import SecondaryButton from '../../buttons/SecondaryButton';
import PrimaryInput from '../../inputs/PrimaryInput';
import PrimaryParagraph from '../../texts/PrimaryParagraph';
import PrimaryTitle from '../../texts/PrimaryTitle';
import { PopsizeViewProps } from '../types';

const ResetPasswordView: FC<PopsizeViewProps> = (props) => {
	const [email, setEmail] = useState('');
	const { t } = useTranslation();
	const [sendPasswordResetEmailLoading, setSendPasswordResetEmailLoading] = useState(false);
	const [sendPasswordResetEmailError, setSendPasswordResetEmailError] = useState('');
	const [sendPasswordResetEmailSuccess, setSendPasswordResetEmailSuccess] = useState('');

	const handleSendPasswordResetEmail = async () => {
		setSendPasswordResetEmailLoading(true);
		setSendPasswordResetEmailError('');

		try {
			await sendPasswordResetEmail(auth, email);
			setSendPasswordResetEmailSuccess(t('widget_password_reset_confirmation') || "If the email has a valid account linked to it, you'll receive an email to reset your password.");
		} catch (error: any) {
			console.error('Error during password email sending:', error);
			setSendPasswordResetEmailError(t('user_create_account_email_invalid') || 'Please enter a valid email address');
		} finally {
			setSendPasswordResetEmailLoading(false);
		}
	};

	return (
		<div className={'pop-my-6 pop-fadeIn pop-h-full'}>
			<div className={'pop-flex pop-flex-col pop-justify-center pop-items-center pop-h-full pop-p-5'}>
				<PrimaryTitle className="pop-text-center pop-my-2">{t('reset_password')}</PrimaryTitle>
				<PrimaryParagraph className={'pop-text-sm pop-text-center'}>
					{t('reset_password_message')}
				</PrimaryParagraph>
				<div className={'pop-flex pop-flex-col pop-w-full pop-my-2 pop-px-4'}>
					<div className={'pop-flex pop-flex-col pop-my-4'}>
						<PrimaryInput
							type={'text'}
							placeholder={'Email'}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							className={'pop-w-full'}
						/>
					</div>
					{sendPasswordResetEmailError && (
						<PrimaryParagraph className="pop-text-red-500 pop-mb-4 pop-text-center pop-text-sm">
							{sendPasswordResetEmailError}
						</PrimaryParagraph>
					)}
					{sendPasswordResetEmailSuccess && (
						<PrimaryParagraph className="text-green-500 pop-mb-4 pop-text-center pop-text-sm">
							{sendPasswordResetEmailSuccess}
						</PrimaryParagraph>
					)}
					<SecondaryButton
						className={'pop-bg-popsizeGradientSecondary9050 pop-text-white pop-border-none pop-font-bold pop-text-base'}
						onClick={handleSendPasswordResetEmail}
						isLoading={sendPasswordResetEmailLoading}
						isDisabled={sendPasswordResetEmailLoading || !email}
					>
						{t('reset_password_send')}
					</SecondaryButton>
					<button className={'pop-my-4 hover:pop-underline'} onClick={() => props.toggleView(View.Login)}>
						{t('back')}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ResetPasswordView;
